<template>
  <div class="seemore" >
    <div class="seemore-item" v-for="(item, index)  in seemoreData" :key="index" @click="gotoNextPath(item.path)">
      {{ item.name }}
      <i class="icon icon-bor-arrow-right text-red-400 ml-1 inline-block"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: ['seemoreData'],
  data() {
    return {
    }
  },
  methods: {
    gotoNextPath(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>